import { render, staticRenderFns } from "./AddCommentTextArea.vue?vue&type=template&id=cf6b7122&scoped=true"
import script from "./AddCommentTextArea.vue?vue&type=script&lang=js"
export * from "./AddCommentTextArea.vue?vue&type=script&lang=js"
import style0 from "./AddCommentTextArea.vue?vue&type=style&index=0&id=cf6b7122&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6b7122",
  null
  
)

export default component.exports